import type { SxProps, Theme } from '@mui/material/styles';

/** Shared white panel on leaderboard, pronunciation score, chat, office hours, settings, etc. */
export const PAGE_WHITE_CARD_RADIUS = '16px';

export const pageWhiteCardSx: SxProps<Theme> = {
    backgroundColor: '#FFFFFF',
    borderRadius: PAGE_WHITE_CARD_RADIUS,
    border: 'none',
    boxShadow: 'none',
};
